import { useContext, useEffect, useState } from 'react'
// redux
import { useSelector } from 'react-redux'
import { RootState } from '../../../store'
import { BloqueState } from '../../../store/slices/bloque'
import { SeccionState } from '../../../store/slices/seccion'
// socket
import { SocketContext } from '../../../context/SocketContext'
// LaTeX
import Latex from 'react-latex-next'
// componentes propios
import ModalDiapositiva from './Diapositivas/ModalDiapositiva'
import ModalSeccionEjercicio from './Ejercicios/ModalSeccionEjercicio'
import { Checkbox } from '@mui/material'


type Props = {
  bloque: BloqueState
}

const Secciones = ({ bloque }: Props) => {

  const { socket } = useContext(SocketContext);

  const { secciones, isLoading } = useSelector((state: RootState) => state.seccion);

  const { curso } = useSelector((state: RootState) => state.curso);
  const { usuario } = useSelector((state: RootState) => state.usuario);

  const [seccionesBloque, setSeccionesBloque] = useState<Array<SeccionState>>([])
  const [rol, setRol] = useState('');
  const [grupo, setGrupo] = useState(0);

  useEffect(() => {
    const seccionesBloque = secciones.filter(item => item.bid === bloque.bid);
    setSeccionesBloque(seccionesBloque);
  }, [secciones, bloque]);

  useEffect(() => {
    if (curso.cid !== '' && usuario.uid !== '') {
      const cursoUsuario = usuario.cursos.find(item => item.cid === curso.cid)
      setRol(cursoUsuario?.rol ? cursoUsuario?.rol : '');
      setGrupo(cursoUsuario?.grupo ? cursoUsuario?.grupo : 0);
    }
  }, [curso, usuario]);

  const handleSeccion = (cid: string, mid: string, bid: string, sid: string, grupo: number, activo: boolean | undefined) => {
    if (cid !== '' || mid !== '' || bid !== '' || sid !== '' || grupo !== 0) {
      socket?.emit('actualizar-activo-seccion', {cid: cid, mid: mid, bid: bid, sid: sid, grupo: grupo, activo: !activo});
    }
  }

  if (isLoading) {
    return (
      <div className="d-flex justify-content-center my-3">
        <div className="spinner-border text-success" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    )
  }

  return (
    <div>
      {
        seccionesBloque.map(item => {
          const { cid, mid, bid, sid, activo, ejercicios } = item;
          return (
            <div key={sid} className="card-body px-1 py-2" style={{ borderTop: 'solid 0.1px rgb(0,0,0,0.2)' }} >

              {/* Otra propuesta */}

              <div className='row justify-content-between align-items-center my-0'>
                <div className="col-12">
                  <span style={{ fontSize: '0.9em', color: '#11387b' }}><Latex>{item.nombre}</Latex></span>
                </div>
                <div className="col-md-4">
                  <table className='align-middle'>
                    <tbody>
                      <tr>
                        <td className="text-center" width="40px">
                          <ModalDiapositiva bloque={bloque} seccion={item} />
                        </td>
                        <td>
                          <span style={{ fontSize: '0.9em' }}>Diapositivas</span>
                        </td>
                      </tr>
                    </tbody>
                  </table>

                </div>
                <div className="col-md-8">
                  <table className='align-middle'>
                    <tbody>
                      <tr>
                        {
                          (rol === 'Profesor' || rol === 'Administrador') && 
                          <td className="text-center" width="40px"  >
                            <Checkbox
                              size='small'
                              onClick={() => handleSeccion(cid, mid, bid, sid, grupo, activo)}
                              checked={!!activo}
                            />
                          </td>
                        }
                        {
                          ejercicios && ejercicios.length > 0 &&
                          ejercicios.map(ejercicio => {
                            const { estado } = ejercicio;
                            return (
                              <td className="text-center" width="40px" key={ejercicio.eid} >
                                <ModalSeccionEjercicio ejercicio={ejercicio} activo={activo}/>

                                <div className="progress mx-2" style={{ height: "4px", width: "25px" }}>
                                  {
                                    (estado === true && activo) &&
                                    <div className="progress-bar bg-success" role="progressbar" style={{ width: '100%' }} />
                                  }
                                  {
                                    (estado === false && activo) &&
                                    <div className="progress-bar bg-danger" role="progressbar" style={{ width: '100%' }} />
                                  }
                                </div>
                              </td>
                            )
                          })
                        }
                        {
                          ejercicios && ejercicios.length > 0 &&
                          <td>
                            <span style={{ fontSize: '0.9em' }}>Ejercicios</span>
                          </td>
                        }
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          )
        })
      }
    </div>
  )
}

export default Secciones